import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import requestApi from '../../../api/api';
import globalLoading from '../../../redux/reducers/globalLoading';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { formaListParentsData, fortmatObjectSpouse, fortmatSpouseData } from '../../../helpers/formatdata';
import { toastError, toastSuccess } from '../../../helpers/toast';
import Select from 'react-select'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import { editorConfiguration } from '../../../config/editorConfiguration';



const SpouseUpdate = () => {
  const { t } = useTranslation(['title', 'table', 'form', 'sidebar', 'button', 'notiSuccess', 'notiError', 'notiWarning']);
  const schema = yup.object().shape({
    person: yup
      .object()
      .shape({
        label: yup.string().required(t('notiWarning:spouse_required')),
        value: yup.string().required('Spouse is required')
      })
      // .nullable() // for handling null value when clearing options via clicking "x"
      .required("Spouse is required"),
    first_name: yup.string().required(t('notiWarning:first_name_required')),
    last_name: yup.string().required(t('notiWarning:last_name_required')),
    chinese_name: yup.string(),
    note_name: yup.string(),
    address: yup.string(),
    birth_place: yup.string(),
    burial_place: yup.string(),
    birthday: yup.string(),
    dead_day: yup.string(),
    gender: yup.string(),
    relation: yup.string(),
    note: yup.string(),
  });
  const params = useParams();
  const { register, setValue, control, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [optionPerson, setOptionPerson] = useState([]);
  const [person, setPersonData] = useState(null);
  const [noteData, setNoteData] = useState({});
  const [birthday, setBirthday] = useState(new Date());
  const [deadDay, setDeadDay] = useState(new Date());
  const [selectedRelation, setSelectedRelation] = useState('Other');

  useEffect(() => {
    dispatch(globalLoading.actions.CONTROL_LOADING(true));
    try {
      const getDetailSpouse = async () => {
        const res = await requestApi(`/marriage-person/${params.id}`, 'GET');
        dispatch(globalLoading.actions.CONTROL_LOADING(false));
        const fields = ['person', 'first_name', 'last_name',
          'chinese_name', 'note_name', 'relation', 'gender', 'address', 'birth_place',
          'burial_place', 'wife_hierarchy'
        ];
        const data = fortmatSpouseData(res.data.data.items);
        // console.log('data hay day--.', data[0])
        // const formatPerson = [{
        //   value: data[0].person._id,
        //   label: data[0].person.full_name
        // }];
        fields.forEach((field) => setValue(field, data[0][field]));
        setNoteData(data[0].note);
        setPersonData(data[0].person);
        setSelectedRelation(data[0].relation);
        setBirthday(data[0].birthday ? new Date(data[0].birthday) : '');
        setDeadDay(data[0].dead_day ? new Date(data[0].dead_day) : '');
        // console.log('hung----->',formatDate(new Date(data[0].birthday)) );
      }
      getDetailSpouse();
    } catch (error) {
      // console.log('error-->', error);
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
    }

  }, []);

  useEffect(() => {
    dispatch(globalLoading.actions.CONTROL_LOADING(true));
    try {
      const getListParent = async () => {
        const res = await requestApi('/person', 'GET');
        dispatch(globalLoading.actions.CONTROL_LOADING(false));
        setOptionPerson(formaListParentsData(res.data.data.items));
      }
      getListParent();
    } catch (error) {
      // console.log('error-->', error);
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
    }
  }, []);

  useEffect(() => {
    register('note')
  })


  const handleSubmitFormUpdate = async (data) => {
    // console.log('data form update ===>', data);
    data.person = person;
    data['birthday'] = birthday;
    data['dead_day'] = deadDay;
    if (data.relation !== 'Wife') {
      data['wife_hierarchy'] = '';
    }
    dispatch(globalLoading.actions.CONTROL_LOADING(true));
    const dataInput = fortmatObjectSpouse(data);
    // console.log('data form update ===>', data);
    try {
      const result = await requestApi(`/marriage-person/${params.id}`, 'PATCH', dataInput);
      // console.log('result------>', result);
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      // toastSuccess('Spouse has updated successfully!!!', 1000);
      toastSuccess(t('notiSuccess:spouse_updated_success'), 1000);
      setTimeout(() => {
        navigate('/admin/spouse')
      }, 100);
    } catch (error) {
      // console.log('error------->', error);
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      // toastError('Update spouse failed', 2000);
      toastError(t('notiError:update_spouse_failed'), 2000);
    }

  }
  const handleChangeOptions = (selectedOption) => {
    setPersonData(selectedOption);
    // console.log('data origin -->', person);
    // console.log('selected option-->', selectedOption);
  }
  return (
    <div id="layoutSidenav_content">
      <main>
        <div className="container-fluid px-4">
          <h1 className="mt-4">
            {/* Update Spouse */}
            {t('title:update_spouse')}
          </h1>
          <ol className="breadcrumb mb-4">
            <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar:dashboard')}</Link></li>
            <li className="breadcrumb-item"><Link to='/admin/spouse'>{t('title:spouse_list')}</Link></li>
            <li className="breadcrumb-item active">{t('title:update_spouse')}</li>
          </ol>
          <div className='card mb-4'>
            <div className='card-header'>
              <i className='fas fa-plus me-1'></i>
              {t('title:update')}
            </div>
            <div className='card-body'>
              <div className='row mb-3'>
                <form>
                  <div className="row">
                    <div className='col'>
                      <label className='form-label'>
                        {/* Last name: */}
                        {t('form:title.last_name')}
                      </label>
                      <input {...register("last_name", { required: 'Last name is required.' })} type='text' className='form-control' placeholder={t('form:place_holder.enter_last_name')} />
                      {errors.last_name && <p style={{ color: 'red' }}>{errors.last_name.message}</p>}
                    </div>
                    <div className='col'>
                      <label className='form-label'>
                        {/* First name: */}
                        {t('form:title.first_name')}
                      </label>
                      <input {...register("first_name", { required: 'First name is required.' })} type='text' className='form-control' placeholder={t('form:place_holder.enter_first_name')} />
                      {errors.first_name && <p style={{ color: 'red' }}>{errors.first_name.message}</p>}
                    </div>
                  </div>
                  <div className="row mb-3 mt-4">
                    <div className='col'>
                      <label className='form-label'>
                        {/* Chinese name: */}
                        {t('form:title.other_name')}
                      </label>
                      <input {...register("chinese_name")} type='text' className='form-control' placeholder={t('form:place_holder.enter_other_name')} />
                    </div>
                    <div className='col'>
                      <label className='form-label'>
                        {/* Note name: */}
                        {t('form:title.note_name')}
                      </label>
                      <input  {...register("note_name")} type='text' className='form-control' placeholder={t('form:place_holder.enter_note_name')} />
                    </div>
                  </div>
                  <div className="row mb-3 mt-4">
                    <div className='col'>
                      <label className='form-label'>
                        {/* Address: */}
                        {t('form:title.address')}
                      </label>
                      <input {...register("address")} type='text' className='form-control' placeholder={t('form:place_holder.enter_address')} />
                    </div>
                    <div className='col'>
                      <label className='form-label'>
                        {/* Place of birth: */}
                        {t('form:title.place_birth')}
                      </label>
                      <input {...register("birth_place")} type='text' className='form-control' placeholder={t('form:place_holder.enter_place_birth')} />
                    </div>
                  </div>
                  <div className="row mb-3 mt-4">
                    <div className='col'>
                      <label className='form-label'>
                        {/* Burial ground: */}
                        {t('form:title.burial_ground')}
                      </label>
                      <input {...register("burial_place")} type='text' className='form-control' placeholder={t('form:place_holder.enter_burial_ground')} />
                    </div>
                    <div className='col-3'>
                      <label className='form-label'>
                        {t('form:title.date_birth')}
                      </label>
                      <Controller
                        name='birthday'
                        control={control}
                        render={({ field }) => (
                          <span style={{ display: 'flex' }} className='customDatePickerWidth'>
                            <DatePicker
                              {...field}
                              className='form-control example-custom-input'
                              selected={birthday}
                              value={birthday}
                              onChange={(date) => {
                                // const newDate = new Date(date).toLocaleDateString();
                                // console.log('Date of birth new-->', formatDate(date));
                                // console.log('Date of birth new-->', date);
                                setBirthday(date)
                              }}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              scrollableYearDropdown={false}
                              dateFormat="dd-MM-yyyy"
                              maxDate={new Date()}
                              todayButton="TODAY"
                            />
                          </span>
                        )}
                      />
                    </div>
                    <div className='col-3'>
                      <label className='form-label'>
                        {t('form:title.date_death')}
                      </label>
                      <Controller
                        name='dead_day'
                        control={control}
                        render={({ field }) => (
                          <div style={{ display: 'flex' }} className='customDatePickerWidth'>
                            <DatePicker
                              {...field}
                              className='form-control example-custom-input'
                              selected={deadDay}
                              value={deadDay}
                              onChange={(date) => {
                                // console.log('Dead day new-->', date);
                                setDeadDay(date)
                              }}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              scrollableYearDropdown={false}
                              dateFormat="dd-MM-yyyy"
                              maxDate={new Date()}
                              todayButton="TODAY"
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 mt-4">
                    {/* <div className='col-6'>
                      <label className='form-label'>
                        {t('form:title.date_death')}
                      </label>
                      <Controller
                        name='dead_day'
                        control={control}
                        render={({ field }) => (
                          <div style={{ display: 'flex' }}>
                            <DatePicker
                              {...field}
                              className='form-control example-custom-input'
                              selected={deadDay}
                              value={deadDay}
                              onChange={(date) => {
                                // console.log('Dead day new-->', date);
                                setDeadDay(date)
                              }}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              scrollableYearDropdown={false}
                              dateFormat="dd-MM-yyyy"
                              maxDate={new Date()}
                              todayButton="TODAY"
                            />
                          </div>
                        )}
                      />
                    </div> */}
                    <div className='col-3'>
                      <label className='form-label'>
                        {/* Spouse: */}
                        {t('form:title.spouse')}
                      </label>
                      {/* <select onChange={(e) => setPersonData(e.target.value)} className='form-select'>
                        {
                          optionPerson.map((opts, i) => <option key={i}> {opts.label}</option>)
                        }
                      </select> */}
                      <Controller
                        name='person'
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            // isClearable
                            isSearchable={true}
                            className="react-dropdown"
                            classNamePrefix="dropdown"
                            options={optionPerson}
                            placeholder="Select Spouse"
                            // onChange={handleChangeOptions}
                            defaultValue={person}
                            value={person}
                            onChange={(selectedOption) => {
                              setPersonData(selectedOption)
                              // field.value = selectedOption;
                            }}
                            autoFocus={true}
                          />
                        )}
                      />
                      <p style={{ color: 'red' }}>{errors.person?.message || errors.person?.label.message}</p>
                    </div>
                    <div className='col-3'>
                      <label className='form-label'>
                        {t('form:title.gender')}
                      </label>
                      <select  {...register("gender")} className='form-select'>
                        <option value='Other'>{t('form:select.other')}</option>
                        <option value='Male'>{t('form:select.male')}</option>
                        <option value='Female'>{t('form:select.female')}</option>
                      </select>
                    </div>
                    <div className='col-3'>
                      <label className='form-label'>
                        {t('form:title.relation_spouse')}
                      </label>
                      <select  {...register("relation")} onChange={e => setSelectedRelation(e.target.value)} defaultValue={'Other'} className='form-select'>
                        <option value='Other'>{t('form:select.other')}</option>
                        <option value='Husband'>{t('form:select.husband')}</option>
                        <option value='Wife'>{t('form:select.wife')}</option>
                      </select>
                    </div>
                    <div className='col-3'>
                      <label className='form-label'>
                        {t('form:title.wife_hierarchy')}  ({t('notiWarning:when_relationship_wife')})
                      </label>
                      {
                        selectedRelation === 'Wife' ?
                          <select  {...register("wife_hierarchy")} defaultValue={'last_wife'} className='form-select'>
                            <option value='main_wife'>{t('form:select.main_wife')}</option>
                            <option value='concubine'>{t('form:select.concubine')}</option>
                            <option value='last_wife'>{t('form:select.last_wife')}</option>
                          </select> :
                          <select disabled {...register("wife_hierarchy")} defaultValue={'last_wife'} className='form-select'>
                            <option value='main_wife'>{t('form:select.main_wife')}</option>
                            <option value='concubine'>{t('form:select.concubine')}</option>
                            <option value='last_wife'>{t('form:select.last_wife')}</option>
                          </select>

                      }
                    </div>
                  </div>
                  <div className="row mb-3 mt-4">
                    <div className='col-6'>
                      <label htmlFor="noteTextarea1" className='form-label'>
                        {t('form:title.note')}
                      </label>
                      <CKEditor
                        className="ck-editor_editable_inline"
                        editor={Editor}
                        config={editorConfiguration}
                        data={noteData}
                        onReady={editor => {
                          register("note")
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          // console.log({ event, editor, data });
                          setValue('note', data);

                        }}
                      />
                    </div>
                    <div className='col-3 mt-2'>
                      <button onClick={handleSubmit(handleSubmitFormUpdate)} type='button' className='mt-4 btn btn-success'>{t('button:submit')}</button>
                      <Link to={'/admin/spouse'} style={{ marginLeft: '10px' }} className='mt-4 btn btn-danger' >{t('button:cancel')}</Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>

    </div>
  )
}

export default SpouseUpdate